// extracted by mini-css-extract-plugin
export default {"pagination":"styles_pagination__p+fFZ"};